import TravelModeSelectorButton from '@components/nearby/travel_mode/TravelModeSelectorButton'
import { colors, size } from '@styles/theme'
import styled from '@emotion/styled'
import {
  PiAirplaneTilt,
  PiBellBold,
  PiChatCircleTextBold,
  PiNewspaperBold,
  PiPlant,
} from 'react-icons/pi'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: ${size(30)};
`

const EmptyIcon = styled.div`
  background-color: #333333;
  // background-color: #31303d;
  margin: 0 auto ${size(2.5)} auto;
  border-radius: 100px;
  padding: ${size(2.5)};
  display: flex;
  align-items: center;
  justify-content: center;
`

const EmptyText = styled.h2`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${size(1)};
  font-size: ${size(2.75)};
`

const EmptyState = ({ MacroIcon=PiPlant, TextIcon, text, containerProps, textProps }) => (
  <Container {...containerProps}>
    <EmptyIcon>
      <MacroIcon size={size(5)} />
    </EmptyIcon>
    <EmptyText {...textProps}>
      {TextIcon && <TextIcon size={size(3)} style={{ flexShrink: 0 }} />}
      {text}
    </EmptyText>
  </Container>
)

const EmptyFeed = ({ containerProps, text='No Posts Yet', textProps, noIcon=false }) => (
  <EmptyState
    containerProps={containerProps}
    textProps={textProps}
    TextIcon={!noIcon && PiNewspaperBold}
    text={text}
  />
)

const EmptyMessages = ({ containerProps }) => (
  <EmptyState
    containerProps={containerProps}
    TextIcon={PiChatCircleTextBold}
    text='No Messages Yet'
  />
)

const EmptyNotifications = ({ containerProps }) => (
  <EmptyState
    containerProps={containerProps}
    TextIcon={PiBellBold}
    text='No Notifications Yet'
  />
)

const EndOfGridContent = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${size(3)};
  text-align: center;
`

const endOfGridProps = {
  container: { style: { padding: `${size(10)} 0 ${size(20)} 0` } },
  travelContent: { style: { color: 'white' } },
  travelIcon: { style: { fill: 'white' } },
  travelContainer: { style:
    {
      backgroundColor: colors.statusColors.right_now('primary'),
      display: 'flex',
      width: '100%',
      maxWidth: size(40)
    }
  },

}

const EndOfGrid = () => (
  <EmptyState
    containerProps={endOfGridProps.container}
    MacroIcon={PiAirplaneTilt}
    text={
      <EndOfGridContent>
        Use travel mode<br />to see more profiles
          <TravelModeSelectorButton
            containerProps={endOfGridProps.travelContainer}
            contentProps={endOfGridProps.travelContent}
            iconProps={endOfGridProps.travelIcon}
          />
      </EndOfGridContent>}
  />
)

export default EmptyState
export { EmptyFeed, EmptyMessages, EmptyNotifications, EndOfGrid }
